var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","fill-height":""}},[_c('ApolloQuery',{staticClass:"fill-height",attrs:{"fetchPolicy":"network-only","query":require('../graphql/queries/stations.gql'),"client-id":"clientPrivate"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(data)?[_c('map-with-position',{attrs:{"enable-user-position":"","markers":data.stations.nodes,"initial-zoom":12,"initial-center":{lat: 45, lng: 10}}})]:_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }